//基础配置
export default [
    {
        path: 'basicConfiguration',
        name: 'basicConfiguration',
        meta: {
            title: '基础配置',
            icon: 'basicConfiguration'
        },
        hidden: false,
        component: () => import("@/views/system/basicConfiguration/index.vue"),
        children: [{
            path: 'appAdvertising',
            name: 'appAdvertising',
            meta: {
                title: 'app广告',
                icon: 'appAdvertising'
            },
            hidden: false,
            component: () => import("@/views/system/basicConfiguration/appAdvertising.vue"),
        }, {
            path: 'appAgreement',
            name: 'appAgreement',
            meta: {
                title: 'app协议',
                icon: 'appAgreement'
            },
            hidden: false,
            component: () => import("@/views/system/basicConfiguration/appAgreement.vue"),
        }]
    }

]